import React from "react";
import * as fetchingState from '../../../constants/fetchingState';
import { Alert, Glyphicon } from "react-bootstrap";
import * as permissions from '../../../constants/permissions';
import { UnstiledDropdownListField } from '../../common/Inputs';
import { departments as departmentSettingsType } from '../../../constants/settingTypes';
import { RECEIVING_POINT } from "../../../constants/dcDepartmentTypes";
import { Field, reduxForm, getFormValues } from "redux-form";
import { connect } from 'react-redux';


let Table = class extends React.Component{
     constructor(props) {
        super(props);
     }
     
     render() {
        const { employees, fetching, onEdit, isReadOnly, isReceptionPoint, useReceptionPointFilter, receptionPoints, formValues } = this.props;

        const renderRow = (employee, onEdit, isReadOnly, isReceptionPoint) => (
            <tr key={employee.Id}>
                <td>{employee.Name}</td>
                <td>{employee.Login}</td>
                <td>{permissions.getRoleNameById(employee.Role)}</td>
                {isReceptionPoint && <td>{employee.Department ? employee.Department.FullName : undefined}</td>}
                <td>{employee.Phone}</td>
                <td>{employee.Location}</td>
                <td>{employee.User.IsActive ? "Да" : "Нет"}</td>
                <td>
                    <Glyphicon glyph='pencil' 
                    className={`edit-glyph${isReadOnly ? '.disabled' : ''}`} 
                    onClick={isReadOnly ? undefined : () => onEdit(employee)} />
                </td>
            </tr>);

            const filterEmployees = (employees) => {
                if (!this.props.useReceptionPointFilter)
                    return employees;

                var selectedReceptionPoint = formValues && formValues.ReceptionPoint ? formValues.ReceptionPoint : undefined;
                if (!selectedReceptionPoint)
                    return employees;
                
                return employees.filter(e => e.Department && e.Department.Id == selectedReceptionPoint.Id);
            };
            const showFilter = useReceptionPointFilter && receptionPoints && receptionPoints.length != 0;
        return(
            <div>
                {fetching === fetchingState.FETCHING && <Alert bsStyle='info'>Загрузка...</Alert>}
                {fetching === fetchingState.FAILED && <Alert bsStyle='danger'>Ошибка загрузки</Alert>}
                {fetching === fetchingState.FETCHED &&
                    <div className="jobs-container-filter">
                        <div className="row jobs-container-filter" >
                            <div className={`${showFilter ? 'col-md-3' : 'col-md-12'}`} >
                                {showFilter && 
                                    <Field component={UnstiledDropdownListField} 
                                        data={receptionPoints} 
                                        name='ReceptionPoint'
                                        textField='FullName'   
                                        valueField='Id'                    
                                    />}
                            </div>
                        </div>
                        <table className='table table-hover'>
                            <thead>
                                <tr>
                                    <td>ФИО</td>
                                    <td>Логин</td>
                                    <td>Роль</td>
                                    {isReceptionPoint && <td>Пункт приема</td>}
                                    <td>Номер телефона</td>
                                    <td>Локация</td>
                                    <td>Действует</td>
                                    <td></td>
                                </tr>
                            </thead>
                            <tbody>
                                {filterEmployees(employees).map(e => renderRow(e, onEdit, isReadOnly, isReceptionPoint))}
                            </tbody>
                        </table>
                    </div>}
            </div>);
    }
}

function mapToProps(state, props) {
    const departments = state.application.get('settings')[departmentSettingsType];
    const receptionPoints = departments && departments.data ? departments.data.filter(d => d.Type == RECEIVING_POINT) : undefined;
    const formValues = getFormValues('EmployeeTable')(state);
    return {
        receptionPoints,
        formValues
    }
}

Table = reduxForm({
    form: 'EmployeeTable'
})(Table);

Table = connect(mapToProps, { getFormValues } )(Table);
export default Table;


// WEBPACK FOOTER //
// ./src/components/settings/employee/EmployeeTable.jsx